import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponse, checkChatRoomExistence } from '~/api';
import {
  ApiError,
  CheckChatRoomExistenceRequest,
  CheckChatRoomExistenceResponse,
} from '~/types';
import { PAGE_ROUTE } from '~/constants';
import useToast from '~/store/useToast';
import chatRoomKey from './chatRoomKey';

const useCheckExistenceMutation = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<CheckChatRoomExistenceResponse>,
    ApiError,
    CheckChatRoomExistenceRequest
  >({
    mutationFn: checkChatRoomExistence,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: chatRoomKey.getChatList(),
      });
    },
    onError: (error) => {
      console.error(error);
      if (error.status === 400) {
        navigate(PAGE_ROUTE.MAIN);
        showToast('error', error.body.message || 'Cannot check room existence');
      } else {
        showToast('error', 'Cannot check room existence');
      }
    },
  });
};

export default useCheckExistenceMutation;
